const APIURL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
  ? "http://localhost:8080"
  : "https://api.bybcult.com";
// http://35.193.69.131:8080
console.log("API URL:", APIURL);
//const APIURL ="http://35.193.69.131:8080" //"http://localhost:8080" //"http://10.0.2.2:8080"//"http://34.131.190.22"//  
// const APIURL ="https://34.131.217.12" 
import axios from 'axios';



// components/Api.js
const getToken = () => {
  const token = localStorage.getItem('accessToken');
  const tokenType = localStorage.getItem('tokenType') || 'Bearer';
  return token ? `${tokenType} ${token}` : null;
};

// Add axios interceptor to handle token expiration
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Check if the error is due to token expiration (401 Unauthorized)
    if (error.response && error.response.status === 401) {
      // Check if this is actually invalid credentials vs token expiration
      // For invalid credentials, the backend sends {"status":"UNAUTHORIZED","message":"Invalid credentials"}
      const isInvalidCredentials = error.response.data &&
        error.response.data.status === "UNAUTHORIZED" &&
        error.response.data.message === "Invalid credentials";

      // Only dispatch tokenExpired for actual token expiration, not invalid credentials
      if (!isInvalidCredentials) {
        // Dispatch a custom event to notify the app about token expiration
        window.dispatchEvent(new CustomEvent('tokenExpired'));
      }
    }
    return Promise.reject(error);
  }
);

// Login User

const loginUser = async (email, password) => {
  console.log("Login API called with:", { email, password })
  console.log("API URL:", APIURL + '/api/v1/auth/login')

  var config = {
    method: 'post',
    url: APIURL + '/api/v1/auth/login',
    headers: {
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({
      username: email,
      password: password,
    }),
  };

  try {
    const response = await axios(config)
    console.log("Login API response:", response)
    return response
  } catch (error) {
    console.error("Login API error:", error)
    console.error("Error response:", error.response)
    throw error
  }
};

//Get total stats

//http://localhost:8080/api/subscription-plans/stats

const Getstats = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }

  var config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/dashboard/statistics'
    ,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config)

};

// Dashboard Analytics APIs
const GetSubscribedUsersStats = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/dashboard/statistics/subscribed-users',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const GetRevenueAnalytics = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/dashboard/analytics/revenue',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const GetUserEngagementAnalytics = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/dashboard/analytics/user-engagement',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const GetTrainerPerformanceAnalytics = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/dashboard/analytics/trainer-performance',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const GetContentAnalytics = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/dashboard/analytics/content',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const GetSystemHealthMetrics = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/dashboard/analytics/system-health',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};


// Create master data (PDF/Video) and assign to user
const CreateMasterDataAndAssign = async (userID, title, description, categories, file, dataType) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }

  // Step 1: Create master data entry
  const formData = new FormData();
  formData.append('name', title);
  formData.append('description', description);
  formData.append('category', categories);
  formData.append('dataType', dataType); // PDF_DOCUMENT or VIDEO_CONTENT
  formData.append('file', file);
  formData.append('isPublic', 'false');

  const createConfig = {
    method: 'post',
    url: APIURL + '/api/v1/admin/master-data',
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': token,
    },
    data: formData,
  };

  const createResponse = await axios(createConfig);
  const masterDataId = createResponse.data.masterDataId;

  // Step 2: Grant access to the user
  const accessRequest = {
    userIds: [userID],
    accessType: 'MANUAL_GRANT',
    grantedBy: 'Admin',
    reason: `Assigned ${dataType.toLowerCase()} to user`
  };

  const assignConfig = {
    method: 'post',
    url: APIURL + `/api/v1/admin/master-data/${masterDataId}/access`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
    data: accessRequest,
  };

  return await axios(assignConfig);
};

// Legacy function for backward compatibility
const UploadPDF = async (userID, title, description, categories, file) => {
  return await CreateMasterDataAndAssign(userID, title, description, categories, file, 'PDF_DOCUMENT');
};

// Legacy function for backward compatibility
const UploadVideo = async (userID, title, description, categories, file) => {
  return await CreateMasterDataAndAssign(userID, title, description, categories, file, 'VIDEO_CONTENT');
};

const UploadVideotoallUser = async (title, description, sequence, category, tags, videoFile, thumbnailFile) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const formData = new FormData();
  formData.append('title', title);
  formData.append('description', description || '');
  formData.append('sequence', sequence.toString());
  formData.append('category', category || '');
  formData.append('tags', tags || '');
  formData.append('videoFile', videoFile);
  if (thumbnailFile) {
    formData.append('thumbnailFile', thumbnailFile);
  }


  const config = {
    method: 'post',
    url: APIURL + '/api/v1/admin/global-videos',
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': token,
    },
    data: formData,
  };
  return await axios(config);
};


const UpdateVideotoallUser = async (id, title, description, sequence, category, tags, videoFile, thumbnailFile) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const formData = new FormData();
  formData.append('title', title);
  formData.append('description', description || '');
  formData.append('sequence', sequence.toString());
  formData.append('category', category || '');
  formData.append('tags', tags || '');
  if (videoFile) {
    formData.append('videoFile', videoFile);
  }
  if (thumbnailFile) {
    formData.append('thumbnailFile', thumbnailFile);
  }


  const config = {
    method: 'put',
    url: APIURL + '/api/v1/admin/global-videos/' + id,
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': token,
    },
    data: formData,
  };
  return await axios(config);
};

const Deletevideotoallusers = async (id) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'delete',
    url: APIURL + '/api/v1/admin/global-videos/' + id
    ,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config)

};

const GetAllideotoallusers = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/global-videos'
    ,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config)

};

const CreateTesomonial = async (name, role, text, rating) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'post',
    url: APIURL + '/api/v1/admin/content/testimonials',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
    data: JSON.stringify({
      name: name,
      role: role,
      text: text,
      rating: rating
    }),
  };
  return await axios(config)

};

const UpdateTesomonial = async (id, name, role, text, rating) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'put',
    url: APIURL + '/api/v1/admin/content/testimonials/' + id,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
    data: JSON.stringify({
      name: name,
      role: role,
      text: text,
      rating: rating
    }),
  };
  return await axios(config)

};

const AllTesomonial = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/content/testimonials',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config)

};
const DeleteTesomonial = async (id) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'delete',
    url: APIURL + '/api/v1/admin/content/testimonials/' + id,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },

  };
  return await axios(config)

};

const createAddonSession = async (sessionName, durationMinutes, price, currency, description, sessionCount, isActive, appStoreProductId) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'post',
    url: APIURL + '/api/v1/admin/addon-sessions',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
    data: JSON.stringify({
      sessionName: sessionName,
      durationMinutes: durationMinutes,
      price: price,
      currency: currency,
      description: description,
      sessionCount: sessionCount,
      isActive: isActive,
      appStoreProductId: appStoreProductId
    }),
  };
  return await axios(config)

};

const UpdateAddonSession = async (sessionID, sessionName, durationMinutes, price, currency, description, sessionCount, isActive, appStoreProductId) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'put',
    url: APIURL + '/api/v1/admin/addon-sessions/' + sessionID,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
    data: JSON.stringify({
      sessionName: sessionName,
      durationMinutes: durationMinutes,
      price: price,
      currency: currency,
      description: description,
      sessionCount: sessionCount,
      isActive: isActive,
      appStoreProductId: appStoreProductId
    }),
  };
  return await axios(config)

};


const AllAddonSession = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/addon-sessions',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config)

};

const DeleteAddonSession = async (Id) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'delete',
    url: APIURL + '/api/v1/admin/addon-sessions/' + Id,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config)

};

const UplaodBannerHomePage = async (heading, text, sequence, file) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const formData = new FormData();
  formData.append('heading', heading);
  formData.append('text', text);
  formData.append('sequence', sequence);
  formData.append('file', file);
  const config = {
    method: 'post',
    url: APIURL + '/api/v1/admin/content/banners',
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': token,
    },
    data: formData,
  };
  return await axios(config);
};


const UpateBannerHomePage = async (id, heading, text, sequence, file) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const formData = new FormData();

  formData.append('heading', heading);
  formData.append('text', text);
  formData.append('sequence', sequence);
  formData.append('file', file);
  const config = {
    method: 'put',
    url: APIURL + '/api/v1/admin/content/banners/' + id,
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': token,
    },
    data: formData,
  };
  return await axios(config);
};
const GetAllBanner = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/content/banners',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config)

};

const DeleteBanner = async (bannerId) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'delete',
    url: APIURL + '/api/v1/admin/content/banners/' + bannerId,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config)

};


const CreateTrainer = async (trainerName, email, primarySpecialty, yearsExperience, mobileNumber, bio, hourlyRate, trainerImage) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const formData = new FormData();
  formData.append('trainerName', trainerName);
  formData.append('email', email);
  formData.append('primarySpecialty', primarySpecialty);
  formData.append('yearsExperience', yearsExperience);
  if (mobileNumber) formData.append('mobileNumber', mobileNumber);
  if (bio) formData.append('bio', bio);
  if (hourlyRate) formData.append('hourlyRate', hourlyRate);
  if (trainerImage) formData.append('trainerImage', trainerImage);
  const config = {
    method: 'post',
    url: APIURL + '/api/v1/admin/content/trainers',
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': token,
    },
    data: formData,
  };
  return await axios(config);
};


const UpdateTrainer = async (id, trainerName, email, primarySpecialty, yearsExperience, mobileNumber, bio, hourlyRate, trainerImage) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const formData = new FormData();

  if (trainerName) formData.append('trainerName', trainerName);
  if (email) formData.append('email', email);
  if (primarySpecialty) formData.append('primarySpecialty', primarySpecialty);
  if (yearsExperience) formData.append('yearsExperience', yearsExperience);
  if (mobileNumber) formData.append('mobileNumber', mobileNumber);
  if (bio) formData.append('bio', bio);
  if (hourlyRate) formData.append('hourlyRate', hourlyRate);
  if (trainerImage) formData.append('trainerImage', trainerImage);
  const config = {
    method: 'put',
    url: APIURL + '/api/v1/admin/content/trainers/' + id,
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': token,

    },
    data: formData,
  };
  return await axios(config);
};

const GetAllTrainer = async () => {
  const token = getToken();
  console.log("Token:", token); // Debug log to check the token value
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/content/trainers',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config)

};

const DeleteTrainer = async (trainerId) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'delete',
    url: APIURL + '/api/v1/admin/content/trainers/' + trainerId,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config)

};


const CreateMeetingLink = async (userId, text, link, important) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  // Prepare the data using URLSearchParams for application/x-www-form-urlencoded
  const params = new URLSearchParams();
  params.append('userId', userId);
  params.append('text', text);
  params.append('link', link);
  params.append('important', important.toString()); // Convert boolean to string

  const config = {
    method: 'post',
    url: APIURL + '/api/subscription-plans/meeting-links/create', // Correct URL as per the cURL
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded', // Content type for form-urlencoded
      'Authorization': token,
    },
    data: params,
  };
  return await axios(config);
};

const GetAllUser = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + '/api/v1/users/getAll',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config)

};
// Login User
const GetUserInfo = async (userID) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + '/api/v1/users/getuseractdetails/' + userID,

    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config)

};
const GetUserActivity = async (userID) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + '/api/v1/users/getuseractdetails/' + userID,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config)

};

// New comprehensive user details API for admin panel
const GetUserAdminDetails = async (userID) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + '/api/v1/users/admin/details/' + userID,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config)

};

// Get user summary data (lightweight)
const GetUserSummary = async (userID) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + '/api/v1/users/user/' + userID + '?format=summary',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config)

};

// Get user complete data (comprehensive)
const GetUserComplete = async (userID) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + '/api/v1/users/user/' + userID + '?format=complete',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config)

};


const GetsuscribeduserInfo = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + '/api/v1/users/getAll',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config)

};
const GetUserPDF = async (userID) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/assignments/pdf/users/' + userID,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config)

};

const GetUserVideo = async (userID) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/assignments/video/users/' + userID,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config)

};

// Create subscription plane 

const createsubscriptionplane = async (planName, timePeriod, durationDays, price, description, features, discountPercentage, appStoreProductId, autoAssignDietChart) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'post',
    url: APIURL + '/api/v1/admin/subscription-plans',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
    data: JSON.stringify({
      planName: planName,
      timePeriod: timePeriod,
      durationDays: durationDays,
      price: price,
      description: description,
      features: features,
      discountPercentage: discountPercentage,
      appStoreProductId: appStoreProductId,
      autoAssignDietChart: autoAssignDietChart
    }),
  };
  return await axios(config)

};

//update plane 

const updatesubscriptionplane = async (id, planName, timePeriod, durationDays, price, description, features, discountPercentage, appStoreProductId, autoAssignDietChart) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'put',
    url: APIURL + '/api/v1/admin/subscription-plans/' + id,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
    data: JSON.stringify({
      planName: planName,
      timePeriod: timePeriod,
      durationDays: durationDays,
      price: price,
      description: description,
      features: features,
      discountPercentage: discountPercentage,
      appStoreProductId: appStoreProductId,
      autoAssignDietChart: autoAssignDietChart
    }),
  };
  return await axios(config)

};
const Deletesubscriptionplane = async (id) => {
  try {
    const token = getToken();
    if (!token) {
      throw new Error('No authentication token available. Please log in.');
    }
    var config = {
      method: 'delete',
      url: APIURL + '/api/v1/admin/subscription-plans/' + id,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token,
      },
    };
    console.log('Delete request config:', config);
    const response = await axios(config);
    console.log('Delete response:', response);
    return response;
  } catch (error) {
    console.error('Delete API error:', error);
    console.error('Error response:', error.response);
    throw error;
  }
};


const sendEmailAPI = async (to, subject, body) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const formData = new URLSearchParams();
  formData.append('to', to);
  formData.append('subject', subject);
  formData.append('body', body);

  const config = {
    method: 'post',
    url: APIURL + '/api/v1/emails',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': token,
    },
    data: formData.toString(),
  };
  return await axios(config)
};

//http://localhost:8080/api/subscription-plans/pdfs/123e4567-e89b-12d3-a456-426614174000

//http://localhost:8080/api/subscription-plans/plans-with-features


const Getsubscriptionplans = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/subscription-plans',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config)
};
//http://localhost:8080/api/subscription-plans/2


const GetPlaneDetails = async (id) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/subscription-plans/' + id,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config)
};

const CreateOrderId = async (productId, userId, totalPrice) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'post',
    url: APIURL + '/api/v1/admin/orders',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
    data: JSON.stringify({
      productId: productId,
      userId: userId,
      totalPrice: totalPrice,
    }),
  };

  return await axios(config);
};
const UpdatePaymentStatusOrderId = async (orderID, status) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'post',
    url: APIURL + '/api/v1/admin/orders/' + orderID + '/payment-status',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
    data: JSON.stringify({
      paymentStatus: status
    }),
  };

  return await axios(config);
};

const AssignoplaneIDToTheUser = async (userID, planeID) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'post',
    url: APIURL + '/api/subscription-plans/subscribe-to-user',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
    data: JSON.stringify({
      userId: userID,
      planId: planeID
    }),
  };
  return await axios(config);
};


const GetSubsDetails = async (id) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/subscription-plans/' + id,

    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config)
};

const GetMeetingsLink = async (id) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + '/api/subscription-plans/meeting-links/' + id,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config)
};

const GetAllOrder = async (id) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/orders',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config)
};

// =========================
// Meeting Slots (Admin)
// =========================

const AdminGetAllMeetingSlots = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/meeting-slots',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminGetMeetingSlotById = async (slotId) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/meeting-slots/' + slotId,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminCreateMeetingSlot = async (payload) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'post',
    url: APIURL + '/api/v1/admin/meeting-slots',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
    data: JSON.stringify(payload),
  };
  return await axios(config);
};

const AdminUpdateMeetingSlot = async (slotId, payload) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'put',
    url: APIURL + '/api/v1/admin/meeting-slots/' + slotId,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
    data: JSON.stringify(payload),
  };
  return await axios(config);
};

const AdminTogglePublishMeetingSlot = async (slotId) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'put',
    url: APIURL + '/api/v1/admin/meeting-slots/' + slotId + '/toggle-publish',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminGenerateMeetingLink = async (slotId) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'post',
    url: APIURL + '/api/v1/admin/meeting-slots/' + slotId + '/generate-meeting-link',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminDeleteMeetingSlot = async (slotId) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'delete',
    url: APIURL + '/api/v1/admin/meeting-slots/' + slotId,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

// =========================
// Addon Plans (Admin)
// =========================

const AdminGetAllAddonPlans = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/addon-plans',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

// =========================
// Trainer Time Slots (Admin)
// =========================

const AdminGetAllTrainerTimeSlots = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/trainer-time-slots/available',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminGetTrainerTimeSlotsByTrainer = async (trainerId) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/trainer-time-slots/trainer/' + trainerId,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminGetTrainerTimeSlotById = async (timeSlotId) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/trainer-time-slots/' + timeSlotId,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminCreateTrainerTimeSlot = async (payload) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'post',
    url: APIURL + '/api/v1/admin/trainer-time-slots',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
    data: JSON.stringify(payload),
  };
  return await axios(config);
};

const AdminUpdateTrainerTimeSlot = async (timeSlotId, payload) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'put',
    url: APIURL + '/api/v1/admin/trainer-time-slots/' + timeSlotId,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
    data: JSON.stringify(payload),
  };
  return await axios(config);
};

const AdminDeleteTrainerTimeSlot = async (timeSlotId) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'delete',
    url: APIURL + '/api/v1/admin/trainer-time-slots/' + timeSlotId,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminGetAvailableOneOnOneSlots = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/trainer-time-slots/available/one-on-one',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminGetAvailableCombinedClasses = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/trainer-time-slots/available/combined-classes',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminCreateAddonPlan = async (payload) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'post',
    url: APIURL + '/api/v1/admin/addon-plans',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
    data: JSON.stringify(payload),
  };
  return await axios(config);
};

const AdminUpdateAddonPlan = async (id, payload) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'put',
    url: APIURL + '/api/v1/admin/addon-plans/' + id,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
    data: JSON.stringify(payload),
  };
  return await axios(config);
};

const AdminDeleteAddonPlan = async (id) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'delete',
    url: APIURL + '/api/v1/admin/addon-plans/' + id,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminToggleAddonPlanStatus = async (id, isActive) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'put',
    url: APIURL + '/api/v1/admin/addon-plans/' + id + '/toggle-status?isActive=' + encodeURIComponent(isActive),
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminGetAddonPlanStats = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/addon-plans/statistics',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

// =========================
// Addon Sessions Activate/Deactivate
// =========================

const ActivateAddonSession = async (id) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'put',
    url: APIURL + '/api/v1/admin/addon-sessions/' + id + '/activate',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const DeactivateAddonSession = async (id) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'put',
    url: APIURL + '/api/v1/admin/addon-sessions/' + id + '/deactivate',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

// Approval Request APIs
const AdminGetPendingApprovalRequests = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/trainer-time-slots/pending-approvals',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminApproveOneOnOneSession = async (timeSlotId, approvalNotes = '') => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'post',
    url: APIURL + '/api/v1/admin/trainer-time-slots/' + timeSlotId + '/approve',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
    data: {
      notes: approvalNotes
    }
  };
  return await axios(config);
};

const AdminRejectOneOnOneSession = async (timeSlotId, rejectionNotes = '') => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'post',
    url: APIURL + '/api/v1/admin/trainer-time-slots/' + timeSlotId + '/reject',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
    data: {
      notes: rejectionNotes
    }
  };
  return await axios(config);
};

const AdminGetBookedOneOnOneSessions = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/trainer-time-slots/booked/one-on-one',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

// =========================
// Diet Chart Management APIs
// =========================

// Diet Chart CRUD Operations
const AdminGetAllDietCharts = async (page = 0, size = 20, search = '', isActive = '') => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  
  let url = APIURL + `/api/v1/admin/diet-charts?page=${page}&size=${size}`;
  if (search) {
    url += `&search=${encodeURIComponent(search)}`;
  }
  if (isActive !== '') {
    const isActiveBool = isActive === 'ACTIVE' || isActive === 'active';
    url += `&isActive=${isActiveBool}`;
  }
  
  const config = {
    method: 'get',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminGetAllDietChartsList = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/diet-charts/all',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminGetActiveDietCharts = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/diet-charts/active',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminGetDietChartById = async (id) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'get',
    url: APIURL + `/api/v1/admin/diet-charts/${id}`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminCreateDietChart = async (payload) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'post',
    url: APIURL + '/api/v1/admin/diet-charts',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
    data: JSON.stringify(payload),
  };
  return await axios(config);
};

const AdminUpdateDietChart = async (id, payload) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'put',
    url: APIURL + `/api/v1/admin/diet-charts/${id}`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
    data: JSON.stringify(payload),
  };
  return await axios(config);
};

const AdminBulkUploadDietCharts = async (file) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const formData = new FormData();
  formData.append('file', file);

  const config = {
    method: 'post',
    url: APIURL + '/api/v1/admin/diet-charts/bulk-upload',
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': token,
    },
    data: formData,
  };
  return await axios(config);
};

const AdminDeleteDietChart = async (id) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'delete',
    url: APIURL + `/api/v1/admin/diet-charts/${id}`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminActivateDietChart = async (id) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'put',
    url: APIURL + `/api/v1/admin/diet-charts/${id}/activate`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminDeactivateDietChart = async (id) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'put',
    url: APIURL + `/api/v1/admin/diet-charts/${id}/deactivate`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};



// =========================
// Diet Chart Assignment APIs
// =========================

const AdminAssignDietChartGlobally = async (dietChartId, assignedBy, reason) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'post',
    url: APIURL + `/api/v1/admin/diet-chart-assignments/assign/global?dietChartId=${dietChartId}&assignedBy=${encodeURIComponent(assignedBy)}&reason=${encodeURIComponent(reason)}`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminAssignDietChartSelectively = async (dietChartId, userIds, assignedBy, reason) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'post',
    url: APIURL + `/api/v1/admin/diet-chart-assignments/assign/selective?dietChartId=${dietChartId}&assignedBy=${encodeURIComponent(assignedBy)}&reason=${encodeURIComponent(reason)}`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
    data: JSON.stringify(userIds),
  };
  return await axios(config);
};

const AdminAssignDietChartBySubscriptionPlan = async (dietChartId, subscriptionPlanId, assignedBy, reason) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'post',
    url: APIURL + `/api/v1/admin/diet-chart-assignments/assign/subscription-plan?dietChartId=${dietChartId}&subscriptionPlanId=${subscriptionPlanId}&assignedBy=${encodeURIComponent(assignedBy)}&reason=${encodeURIComponent(reason)}`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminAssignDietChartByAddonPlan = async (dietChartId, addonPlanId, assignedBy, reason) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'post',
    url: APIURL + `/api/v1/admin/diet-chart-assignments/assign/addon-plan?dietChartId=${dietChartId}&addonPlanId=${addonPlanId}&assignedBy=${encodeURIComponent(assignedBy)}&reason=${encodeURIComponent(reason)}`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminGetUserDietChartAssignments = async (userId) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'get',
    url: APIURL + `/api/v1/admin/diet-chart-assignments/user/${userId}`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminGetUserActiveDietChartAssignments = async (userId) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'get',
    url: APIURL + `/api/v1/admin/diet-chart-assignments/user/${userId}/active`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminGetDietChartAssignments = async (dietChartId) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'get',
    url: APIURL + `/api/v1/admin/diet-chart-assignments/diet-chart/${dietChartId}`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminGetGlobalDietChartAssignments = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/diet-chart-assignments/global',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminGetSelectiveDietChartAssignments = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/diet-chart-assignments/selective',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminUpdateAssignmentProgress = async (assignmentId, completionPercentage, progressNotes = '') => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'put',
    url: APIURL + `/api/v1/admin/diet-chart-assignments/${assignmentId}/progress?completionPercentage=${completionPercentage}&progressNotes=${encodeURIComponent(progressNotes)}`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminCompleteAssignment = async (assignmentId, completionNotes = '') => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'put',
    url: APIURL + `/api/v1/admin/diet-chart-assignments/${assignmentId}/complete?completionNotes=${encodeURIComponent(completionNotes)}`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminCancelAssignment = async (assignmentId, reason, cancelledBy) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'put',
    url: APIURL + `/api/v1/admin/diet-chart-assignments/${assignmentId}/cancel?reason=${encodeURIComponent(reason)}&cancelledBy=${encodeURIComponent(cancelledBy)}`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminSuspendAssignment = async (assignmentId, reason) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'put',
    url: APIURL + `/api/v1/admin/diet-chart-assignments/${assignmentId}/suspend?reason=${encodeURIComponent(reason)}`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminReactivateAssignment = async (assignmentId) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'put',
    url: APIURL + `/api/v1/admin/diet-chart-assignments/${assignmentId}/reactivate`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminGetAssignmentStatistics = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/diet-chart-assignments/statistics',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminGetAssignmentsNeedingRenewal = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/diet-chart-assignments/needing-renewal',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminGetExpiringAssignments = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/diet-chart-assignments/expiring',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminGetAssignmentsByAdmin = async (assignedBy) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'get',
    url: APIURL + `/api/v1/admin/diet-chart-assignments/assigned-by/${encodeURIComponent(assignedBy)}`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminGetAssignmentsByPriority = async (priority) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'get',
    url: APIURL + `/api/v1/admin/diet-chart-assignments/priority/${priority}`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminGetHighCompletionAssignments = async (minCompletionPercentage = 80) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'get',
    url: APIURL + `/api/v1/admin/diet-chart-assignments/high-completion?minCompletionPercentage=${minCompletionPercentage}`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

// =========================
// Google OAuth2 Management
// =========================

const AdminGetGoogleAuthUrl = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/google-oauth2/auth-url',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminHandleGoogleOAuth2Callback = async (code) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'post',
    url: APIURL + '/api/v1/admin/google-oauth2/callback',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
    params: {
      code: code
    }
  };
  return await axios(config);
};

const AdminCheckGoogleOAuth2Status = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  const config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/google-oauth2/status',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

// Admin Management APIs
const createAdminUser = async (userData) => {
  try {
    const token = getToken();
    if (!token) {
      throw new Error('No authentication token available. Please log in.');
    }
    const response = await axios.post(`${APIURL}/api/v1/admin/admin-users/create`, userData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error creating admin user:', error);
    if (error.response?.status === 403) {
      window.dispatchEvent(new CustomEvent('unauthorizedAccess', { detail: { message: 'Access denied: Insufficient permissions' } }));
    }
    throw error;
  }
};

const updateAdminUser = async (adminId, userData) => {
  try {
    const token = getToken();
    if (!token) {
      throw new Error('No authentication token available. Please log in.');
    }
    const response = await axios.put(`${APIURL}/api/v1/admin/admin-users/${adminId}`, userData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating admin user:', error);
    if (error.response?.status === 403) {
      window.dispatchEvent(new CustomEvent('unauthorizedAccess', { detail: { message: 'Access denied: Insufficient permissions' } }));
    }
    throw error;
  }
};

const deactivateAdminUser = async (adminId) => {
  try {
    const token = getToken();
    if (!token) {
      throw new Error('No authentication token available. Please log in.');
    }
    const response = await axios.put(`${APIURL}/api/v1/admin/admin-users/${adminId}/deactivate`, {}, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error deactivating admin user:', error);
    if (error.response?.status === 403) {
      window.dispatchEvent(new CustomEvent('unauthorizedAccess', { detail: { message: 'Access denied: Insufficient permissions' } }));
    }
    throw error;
  }
};

const reactivateAdminUser = async (adminId) => {
  try {
    const token = getToken();
    if (!token) {
      throw new Error('No authentication token available. Please log in.');
    }
    const response = await axios.put(`${APIURL}/api/v1/admin/admin-users/${adminId}/reactivate`, {}, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error reactivating admin user:', error);
    if (error.response?.status === 403) {
      window.dispatchEvent(new CustomEvent('unauthorizedAccess', { detail: { message: 'Access denied: Insufficient permissions' } }));
    }
    throw error;
  }
};

const getAdminUserDetails = async (adminId) => {
  try {
    const token = getToken();
    if (!token) {
      throw new Error('No authentication token available. Please log in.');
    }
    const response = await axios.get(`${APIURL}/api/v1/admin/admin-users/${adminId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error getting admin user details:', error);
    if (error.response?.status === 403) {
      window.dispatchEvent(new CustomEvent('unauthorizedAccess', { detail: { message: 'Access denied: Insufficient permissions' } }));
    }
    throw error;
  }
};

const getAllAdminUsers = async () => {
  try {
    const token = getToken();
    if (!token) {
      throw new Error('No authentication token available. Please log in.');
    }
    const response = await axios.get(`${APIURL}/api/v1/admin/admin-users/all`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error getting all admin users:', error);
    if (error.response?.status === 403) {
      window.dispatchEvent(new CustomEvent('unauthorizedAccess', { detail: { message: 'Access denied: Insufficient permissions' } }));
    }
    throw error;
  }
};

const getAuditTrailsByAdminId = async (adminId, page = 0, size = 10) => {
  try {
    const token = getToken();
    if (!token) {
      throw new Error('No authentication token available. Please log in.');
    }
    const response = await axios.get(`${APIURL}/api/v1/admin/audit-trails/admin/${adminId}?page=${page}&size=${size}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error getting audit trails for admin:', error);
    if (error.response?.status === 403) {
      window.dispatchEvent(new CustomEvent('unauthorizedAccess', { detail: { message: 'Access denied: Insufficient permissions' } }));
    }
    throw error;
  }
};

// User Testimonial Management APIs
const AdminGetPendingTestimonials = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/testimonials/pending',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminApproveTestimonial = async (testimonialId, adminComments = '') => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'post',
    url: APIURL + `/api/v1/admin/testimonials/${testimonialId}/approve`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
    params: {
      adminComments: adminComments
    }
  };
  return await axios(config);
};

const AdminRejectTestimonial = async (testimonialId, rejectionReason) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'post',
    url: APIURL + `/api/v1/admin/testimonials/${testimonialId}/reject`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
    params: {
      rejectionReason: rejectionReason
    }
  };
  return await axios(config);
};

const AdminFeatureTestimonial = async (testimonialId, featured) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'post',
    url: APIURL + `/api/v1/admin/testimonials/${testimonialId}/feature`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
    params: {
      featured: featured
    }
  };
  return await axios(config);
};

const AdminGetAllApprovedTestimonials = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/testimonials/approved',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminGetPendingTestimonialCount = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/testimonials/pending-count',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const AdminDeleteUserTestimonial = async (testimonialId) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'delete',
    url: APIURL + `/api/v1/admin/testimonials/${testimonialId}`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

// Feedback Management APIs
const getAllFeedback = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/feedback',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const getFeedbackById = async (feedbackId) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + `/api/v1/admin/feedback/${feedbackId}`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

const updateFeedbackStatus = async (feedbackId, status) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'put',
    url: APIURL + `/api/v1/admin/feedback/${feedbackId}/status`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
    data: JSON.stringify({ status }),
  };
  return await axios(config);
};

const addAdminResponse = async (feedbackId, response) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'put',
    url: APIURL + `/api/v1/admin/feedback/${feedbackId}/response`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
    data: JSON.stringify({ adminResponse: response }),
  };
  return await axios(config);
};

const searchFeedback = async (searchTerm, filters = {}) => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/feedback/search',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
    params: {
      q: searchTerm,
      ...filters
    },
  };
  return await axios(config);
};

const getFeedbackStats = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('No authentication token available. Please log in.');
  }
  var config = {
    method: 'get',
    url: APIURL + '/api/v1/admin/feedback/stats',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
  };
  return await axios(config);
};

// Diet Combination APIs
const AdminGetAllDietCombinations = async (page = 0, size = 10) => {
  const token = getToken();
  if (!token) throw new Error('No authentication token available. Please log in.');
  const config = {
    method: 'get',
    url: `${APIURL}/api/v1/admin/diet-combinations?page=${page}&size=${size}`,
    headers: { 'Content-Type': 'application/json', 'Authorization': token }
  };
  return await axios(config);
};

const AdminSearchDietCombinations = async (query, page = 0, size = 10) => {
  const token = getToken();
  if (!token) throw new Error('No authentication token available. Please log in.');
  const config = {
    method: 'get',
    url: `${APIURL}/api/v1/admin/diet-combinations/search?q=${encodeURIComponent(query)}&page=${page}&size=${size}`,
    headers: { 'Content-Type': 'application/json', 'Authorization': token }
  };
  return await axios(config);
};

const AdminCreateDietCombination = async (data) => {
  const token = getToken();
  if (!token) throw new Error('No authentication token available. Please log in.');
  const config = {
    method: 'post',
    url: `${APIURL}/api/v1/admin/diet-combinations`,
    headers: { 'Content-Type': 'application/json', 'Authorization': token },
    data
  };
  return await axios(config);
};

const AdminUpdateDietCombination = async (id, data) => {
  const token = getToken();
  if (!token) throw new Error('No authentication token available. Please log in.');
  const config = {
    method: 'put',
    url: `${APIURL}/api/v1/admin/diet-combinations/${id}`,
    headers: { 'Content-Type': 'application/json', 'Authorization': token },
    data
  };
  return await axios(config);
};

const AdminDeleteDietCombination = async (id) => {
  const token = getToken();
  if (!token) throw new Error('No authentication token available. Please log in.');
  const config = {
    method: 'delete',
    url: `${APIURL}/api/v1/admin/diet-combinations/${id}`,
    headers: { 'Content-Type': 'application/json', 'Authorization': token }
  };
  return await axios(config);
};

const AdminBulkIngestDietCombinations = async (file) => {
  const token = getToken();
  if (!token) throw new Error('No authentication token available. Please log in.');
  const formData = new FormData();
  formData.append('file', file);
  const config = {
    method: 'post',
    url: `${APIURL}/api/v1/admin/diet-combinations/bulk-ingest`,
    headers: { 'Content-Type': 'multipart/form-data', 'Authorization': token },
    data: formData
  };
  return await axios(config);
};

const AdminExportDietCombinations = async () => {
  const token = getToken();
  if (!token) throw new Error('No authentication token available. Please log in.');
  const config = {
    method: 'get',
    url: `${APIURL}/api/v1/admin/diet-combinations/export`,
    headers: { 'Authorization': token },
    responseType: 'blob'
  };
  return await axios(config);
};

// Food Macro APIs
const AdminGetAllFoodMacros = async (page = 0, size = 10) => {
  const token = getToken();
  if (!token) throw new Error('No authentication token available. Please log in.');
  const config = {
    method: 'get',
    url: `${APIURL}/api/v1/admin/food-macros?page=${page}&size=${size}`,
    headers: { 'Content-Type': 'application/json', 'Authorization': token }
  };
  return await axios(config);
};

const AdminSearchFoodMacros = async (query, page = 0, size = 10) => {
  const token = getToken();
  if (!token) throw new Error('No authentication token available. Please log in.');
  const config = {
    method: 'get',
    url: `${APIURL}/api/v1/admin/food-macros/search?q=${encodeURIComponent(query)}&page=${page}&size=${size}`,
    headers: { 'Content-Type': 'application/json', 'Authorization': token }
  };
  return await axios(config);
};

const AdminBulkIngestFoodMacros = async (file) => {
  const token = getToken();
  if (!token) throw new Error('No authentication token available. Please log in.');
  const formData = new FormData();
  formData.append('file', file);
  const config = {
    method: 'post',
    url: `${APIURL}/api/v1/admin/food-macros/bulk-ingest`,
    headers: { 'Content-Type': 'multipart/form-data', 'Authorization': token },
    data: formData
  };
  return await axios(config);
};

const AdminCreateFoodMacro = async (data) => {
  const token = getToken();
  if (!token) throw new Error('No authentication token available. Please log in.');
  const config = {
    method: 'post',
    url: `${APIURL}/api/v1/admin/food-macros`,
    headers: { 'Content-Type': 'application/json', 'Authorization': token },
    data: data
  };
  return await axios(config);
};

const AdminUpdateFoodMacro = async (id, data) => {
  const token = getToken();
  if (!token) throw new Error('No authentication token available. Please log in.');
  const config = {
    method: 'put',
    url: `${APIURL}/api/v1/admin/food-macros/${id}`,
    headers: { 'Content-Type': 'application/json', 'Authorization': token },
    data: data
  };
  return await axios(config);
};

const AdminDeleteFoodMacro = async (id) => {
  const token = getToken();
  if (!token) throw new Error('No authentication token available. Please log in.');
  const config = {
    method: 'delete',
    url: `${APIURL}/api/v1/admin/food-macros/${id}`,
    headers: { 'Content-Type': 'application/json', 'Authorization': token }
  };
  return await axios(config);
};

const AdminExportFoodMacros = async () => {
  const token = getToken();
  if (!token) throw new Error('No authentication token available. Please log in.');
  const config = {
    method: 'get',
    url: `${APIURL}/api/v1/admin/food-macros/export`,
    headers: { 'Authorization': token },
    responseType: 'blob'
  };
  return await axios(config);
};


const AdminExportDietCharts = async () => {
  const token = getToken();
  if (!token) throw new Error('No authentication token available. Please log in.');
  const config = {
    method: 'get',
    url: `${APIURL}/api/v1/admin/diet-charts/export`,
    headers: { 'Authorization': token },
    responseType: 'blob'
  };
  return await axios(config);
};

// App Versioning APIs
const UpdateAppVersion = async (versionData) => {
  const token = getToken();
  if (!token) throw new Error('No authentication token available. Please log in.');
  const config = {
    method: 'post',
    url: `${APIURL}/api/v1/admin/app/version`,
    headers: { 'Content-Type': 'application/json', 'Authorization': token },
    data: versionData
  };
  return await axios(config);
};

const GetAppVersion = async (platform) => {
  const config = {
    method: 'get',
    url: `${APIURL}/api/v1/app/version?platform=${platform}`,
  };
  return await axios(config);
};

const GetAllActiveAppVersions = async () => {
  const token = getToken();
  if (!token) throw new Error('No authentication token available. Please log in.');
  const config = {
    method: 'get',
    url: `${APIURL}/api/v1/admin/app/version/active`,
    headers: { 'Content-Type': 'application/json', 'Authorization': token },
  };
  return await axios(config);
};

//http://localhost:8080/api/subscription-plans/subscribe-details/3b1c1efd-751b-4694-999c-631d4375730b
export {
  APIURL,
  Deletesubscriptionplane, Getstats, GetAllUser, GetsuscribeduserInfo, UploadPDF, UploadVideo, CreateMasterDataAndAssign, CreateMeetingLink, GetAllOrder, createsubscriptionplane, updatesubscriptionplane, Getsubscriptionplans,
  //,registerUser,updateUser
  GetPlaneDetails, GetMeetingsLink, GetSubsDetails, AssignoplaneIDToTheUser, UpdatePaymentStatusOrderId, CreateOrderId, loginUser, GetUserInfo, GetUserPDF, GetUserVideo, sendEmailAPI, GetUserActivity, GetUserAdminDetails, GetUserSummary, GetUserComplete,
  GetAllBanner, UpateBannerHomePage, UplaodBannerHomePage, DeleteBanner, CreateTrainer, GetAllTrainer, UpdateTrainer, DeleteTrainer, DeleteTesomonial, AllTesomonial, UpdateTesomonial, CreateTesomonial,
  GetAllideotoallusers, Deletevideotoallusers, UpdateVideotoallUser, UploadVideotoallUser, AllAddonSession, createAddonSession, DeleteAddonSession, UpdateAddonSession, ActivateAddonSession, DeactivateAddonSession,
  AdminGetAllMeetingSlots, AdminCreateMeetingSlot, AdminUpdateMeetingSlot, AdminDeleteMeetingSlot, AdminTogglePublishMeetingSlot, AdminGenerateMeetingLink, AdminGetMeetingSlotById,
  AdminGetAllAddonPlans, AdminCreateAddonPlan, AdminUpdateAddonPlan, AdminDeleteAddonPlan, AdminToggleAddonPlanStatus, AdminGetAddonPlanStats,
  AdminGetAllTrainerTimeSlots, AdminGetTrainerTimeSlotsByTrainer, AdminGetTrainerTimeSlotById, AdminCreateTrainerTimeSlot, AdminUpdateTrainerTimeSlot, AdminDeleteTrainerTimeSlot,
  AdminGetAvailableOneOnOneSlots, AdminGetAvailableCombinedClasses,
  AdminGetPendingApprovalRequests, AdminApproveOneOnOneSession, AdminRejectOneOnOneSession, AdminGetBookedOneOnOneSessions,
  AdminGetGoogleAuthUrl, AdminHandleGoogleOAuth2Callback, AdminCheckGoogleOAuth2Status,
  // Diet Chart Management APIs
  AdminGetAllDietCharts, AdminGetAllDietChartsList, AdminGetActiveDietCharts, AdminGetDietChartById, AdminCreateDietChart, AdminUpdateDietChart, AdminDeleteDietChart,
  AdminActivateDietChart, AdminDeactivateDietChart, AdminBulkUploadDietCharts, AdminExportDietCharts,
  // Diet Chart Assignment APIs
  AdminAssignDietChartGlobally, AdminAssignDietChartSelectively, AdminAssignDietChartBySubscriptionPlan, AdminAssignDietChartByAddonPlan,
  AdminGetUserDietChartAssignments, AdminGetUserActiveDietChartAssignments, AdminGetDietChartAssignments, AdminGetGlobalDietChartAssignments, AdminGetSelectiveDietChartAssignments,
  AdminUpdateAssignmentProgress, AdminCompleteAssignment, AdminCancelAssignment, AdminSuspendAssignment, AdminReactivateAssignment,
  AdminGetAssignmentStatistics, AdminGetAssignmentsNeedingRenewal, AdminGetExpiringAssignments, AdminGetAssignmentsByAdmin, AdminGetAssignmentsByPriority, AdminGetHighCompletionAssignments,
  // Dashboard Analytics APIs
  GetSubscribedUsersStats, GetRevenueAnalytics, GetUserEngagementAnalytics, GetTrainerPerformanceAnalytics, GetContentAnalytics, GetSystemHealthMetrics,
  // User Testimonial Management APIs
  AdminGetPendingTestimonials, AdminApproveTestimonial, AdminRejectTestimonial, AdminFeatureTestimonial, AdminGetAllApprovedTestimonials, AdminGetPendingTestimonialCount, AdminDeleteUserTestimonial,
  // Admin Management APIs
  createAdminUser, updateAdminUser, deactivateAdminUser, reactivateAdminUser, getAdminUserDetails, getAllAdminUsers, getAuditTrailsByAdminId,
  // Feedback Management APIs
  getAllFeedback, getFeedbackById, updateFeedbackStatus, addAdminResponse, searchFeedback, getFeedbackStats,
  AdminGetAllDietCombinations, AdminSearchDietCombinations, AdminCreateDietCombination, AdminUpdateDietCombination, AdminDeleteDietCombination, AdminBulkIngestDietCombinations, AdminExportDietCombinations,
  AdminGetAllFoodMacros, AdminSearchFoodMacros, AdminCreateFoodMacro, AdminUpdateFoodMacro, AdminDeleteFoodMacro, AdminBulkIngestFoodMacros, AdminExportFoodMacros,
  UpdateAppVersion, GetAppVersion, GetAllActiveAppVersions
};
